<template>
  <gjw-dialog
      :show-dialog="showShareModelDialog"
      :title="dialogTitle"
      :config="{ width:'448px', showFooter: false }"
      @close="closeDialog">
    <div>
      <div class="share-file">
        <img class="share-file-icon" :src="getFileIcon(shareFileSuffix)" width="20" alt="" />
        <ellipsis-text :text="shareFileName" />
      </div>
      <div class="share-link-content">
        <div style="height: 100%;">
          <div class="share-link">
            <span class="mg-rt-md">链接访问已{{ shareLinkOpen ? '开启' : '关闭' }}</span>
            <el-switch
                v-model="shareLinkOpen"
                class="confirm-switch"
                active-color="#009EE1"
                inactive-color="#BFBFBF"
                disabled
                @click.native="shareChange(shareLinkOpen)"
            >
            </el-switch>
          </div>
          <div v-if="shareLinkOpen" class="share-link-tip">获得链接的用户可查看轻量化模型</div>
        </div>
        <el-button v-if="shareLinkOpen" type="primary" @click="copyShareLink">复制分享链接</el-button>
      </div>
    </div>
  </gjw-dialog>
</template>

<script>
import EllipsisText from './EllipsisText.vue'
import { shareModelErrorCodeMap } from '../errorCodeMap.js'
import { mapGetters } from 'vuex'
export default {
  name: 'ModelShareDialog',
  props: {
    // 分享类型：
    shareType: {
      type: String,
      default: 'FILE_REVISION',
    }
  },
  components: { EllipsisText },
  data() {
    return {
      spaceId: this.$route.params.spaceId,
      showShareModelDialog: false,
      shareModelFileInfo: {},
      // 分享链接是否开启
      shareLinkOpen: false,
      shareCode: '',
    }
  },
  computed: {
    ...mapGetters({
      user: 'user/user',
    }),
    dialogTitle() {
      return this.shareType === 'FEDERATED_PLAN'
        ? '分享合模方案'
        : this.shareType === 'INTEGRATED_MODEL'
          ? '分享交付模型' : '分享轻量化模型'
    },
    shareFileName() {
      const fileInfo = this.shareModelFileInfo
      return fileInfo.suffix ? `${fileInfo.name}.${fileInfo.suffix}` : `${fileInfo.name}`
    },
    shareFileSuffix() {
      const fileInfo = this.shareModelFileInfo
      return this.shareType === 'FILE_REVISION'
        ? fileInfo.suffix
        : this.shareType === 'FEDERATED_PLAN' ? 'plan' : 'model'
    },
    getFileIcon() {
      return (type) => require(`@/assets/file/${type || 'default'}.png`)
    }
  },
  methods: {
    async openDialog(row) {
      try {
        this.shareModelFileInfo = row
        const shareCode = await this.$api.file.queryShareCode(this.spaceId, row.id, { file_share_type: this.shareType })
        this.shareCode = shareCode
        this.shareLinkOpen = !!shareCode
        this.showShareModelDialog = true
      } catch (err) {
        this.$matchError(err.code, shareModelErrorCodeMap, '获取分享信息失败')
      }
    },
    closeDialog() {
      this.shareModelFileInfo = {}
      this.shareCode = ''
      this.showShareModelDialog = false
    },
    async shareChange(val) {
      const query = {
        file_share_type: this.shareType
      }
      if (!val) {
        this.shareCode = await this.$api.file.createShareCode(this.spaceId, this.shareModelFileInfo.id, query)
        this.shareLinkOpen = true
        this.$emit('share-link-opened', this.shareModelFileInfo)
      } else {
        this.$confirm('是否关闭链接访问？关闭后，当前的访问链接将失效，再次打开将生成新链接。', {
          cancelButtonText: '取消',
          confirmButtonText: '确认关闭',
          showClose: false,
          customClass: 'message-box-class',
          iconClass: 'el-icon-warning'
        }).then(() => {
          this.$api.file.modifyShareCode(this.spaceId, this.shareModelFileInfo.id, this.shareCode, query).then(() => {
            this.shareLinkOpen = false
          })
        }).catch(() => {})
      }
    },
    copyShareLink() {
      const shareUrlMap = {
        FILE_REVISION: 'file',
        FEDERATED_PLAN: 'file/federation',
        INTEGRATED_MODEL: 'file/integrated',
      }
      const url = `${process.env.VUE_APP_PROJECT_HOST}#/${shareUrlMap[this.shareType]}/share/${this.shareCode}`
      const message = `【${this.user.name}】分享给您【${this.shareFileName}】,请点击链接查看：${url}`
      this.$copyText(message).then(() => {
        this.$message.success('已复制到剪贴板')
      }).catch(() => {
        this.$message.error('复制失败')
      })
    },
  },
}
</script>

<style lang="less" scoped>
.share-file{
  padding: 20px 12px;
  margin-bottom: 20px;
  background: #F7F9FA;
  display: flex;
  justify-content: center;
  align-items: center;
  .share-file-icon{
    font-size: 20px;
    margin-right: 4px;
  }
}
.share-link-content{
  height: 48px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .share-link{
    margin-bottom: 6px;
  }
  .share-link-tip{
    color: rgba(73, 95, 112, 0.6);
    font-size: 12px;
  }
}
</style>
